import logger from "debug";
import ns from "@/lib/log/ns";

export const log = (tag: string, formatter: any, ...args: Array<any>) => {
    if (!ns[tag]) {
        ns[tag] = logger(tag);
    }
    ns[tag](formatter, ...args);
}

globalThis.LOG = log;

if (process.env.NODE_ENV === "development") {
    if (!(window as any).web) {
        (window as any).web = {};
    }
    (window as any).web.LOG = log;
}

export default log;
